const INTERNAL_FILE_URL_REGEX =
  /^\/v\d+\/files\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

/**
 * @name isInternalFileUrl
 * @description Indica si una URL guardada apunta a un archivo interno del
 * backend (módulo files, formato `/vN/files/{uuid}`). Esas URLs no pueden
 * pedirse directo desde el browser (exigen headers de auth que solo tiene el
 * servidor) y deben pasar por el proxy same-origin `/api/files/{id}`.
 *
 * @param {string | null} [url] - La URL guardada (p. ej. `document.url` o `imagen_url`).
 * @returns {boolean} `true` si es una URL interna del módulo files.
 */
export const isInternalFileUrl = (url?: string | null): boolean =>
  Boolean(url && INTERNAL_FILE_URL_REGEX.test(url.trim()));

/**
 * @name resolveFileSrc
 * @description Traduce una URL guardada a una URL consumible por el browser:
 * las internas (`/vN/files/{uuid}`) se reescriben al proxy autenticado
 * `/api/files/{uuid}` (la cookie httpOnly de sesión viaja same-origin, apta
 * para `<img>` y links); cualquier otra —URLs externas legacy— se devuelve
 * sin cambios.
 *
 * @param {string} url - La URL guardada.
 * @returns {string} URL lista para usar en `src`/`href`.
 */
export const resolveFileSrc = (url: string): string => {
  const match = url.trim().match(INTERNAL_FILE_URL_REGEX);
  return match ? `/api/files/${match[1]}` : url;
};
